export const Logo = ({ className = "", size = "text-5xl sm:text-6xl" }) => {
  return (
    <div className={`flex flex-col items-center justify-center ${className}`} data-testid="demo-logo">
      <span className={`font-serif-display ${size} font-700 leading-none tracking-tight text-[#FDFBF7]`}>Demo</span>
      <span className="mt-2 text-xs uppercase tracking-[0.4em] text-[#D4AF37]">Restaurant</span>
    </div>
  );
};
